<template>
  <li
    v-if="hasChildren"
    :class="[item.isOpen ? 'nav-item-expanded nav-item-open' : '', 'nav-item nav-item-submenu', itemClass]"
  >
    <a href class="nav-link" @click.prevent="expand">
      <i
        v-if="item.icon"
        :class="[item.icon, item.isOpen ? '' : 'text-muted']"
      />
      <span>{{ itemText }}</span>
    </a>

    <ul
      v-if="item.children && item.children.length > 0"
      :data-submenu-title="itemText"
      class="nav nav-group-sub"
    >
      <template v-for="(child, index) in item.children">
        <sidebar-menu-item
          v-if="hasPermission(child) || hasRole(child.role)"
          :key="child.id || index"
          :item="child"
          @on:click="$emit('on:click', $event)"
          @toggle-expand="$emit('toggle-expand', $event)"
        />
      </template>
    </ul>
  </li>

  <li v-else :class="['nav-item', itemClass]" @click="onItemClick(item)">
    <router-link v-if="item.route" :to="normalizedRoute" class="nav-link">
      <i v-if="item.icon" :class="item.icon" class="text-muted"></i>
      <span>{{ itemText }}</span>
    </router-link>
    <a v-else class="nav-link">
      <i v-if="item.icon" :class="item.icon" class="text-muted"></i>
      <span>{{ itemText }}</span>
    </a>
  </li>
</template>

<script>
import SidebarPermissionMixin from '../../mixins/SidebarPermissionMixin'

export default {
  name: 'SidebarMenuItem',

  // Recursive self-reference for multi-level menu support
  components: {
    SidebarMenuItem: () => import(/* webpackChunkName: "sidebar-menu-item" */ './sidebar-menu-item.vue'),
  },
  mixins: [SidebarPermissionMixin],

  props: {
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },

  computed: {
    hasChildren() {
      return this.item.children && this.item.children.length > 0
    },
    itemText() {
      return this.getItemText(this.item)
    },
    itemClass() {
      const id = this.item.id
      return id ? String(id).replace(/\./g, '-') : ''
    },
    normalizedRoute() {
      const route = this.item.route
      if (!route) return {}
      // Support API format: { name: 'x' }, { path: '/x' }, { name: 'x', params: {} }
      if (typeof route === 'object' && (route.name || route.path)) {
        return route
      }
      return route
    },
  },

  methods: {
    expand() {
      this.$emit('toggle-expand', this.item)
    },
    onItemClick(clickedItem) {
      if (clickedItem.children && clickedItem.children.length) {
        this.$emit('on:click', clickedItem)
      } else if (clickedItem.onClick) clickedItem.onClick(clickedItem)
    },
    getItemText(item) {
      return typeof item.text === 'function' ? item.text(this) : (this.$t(item.text) || '')
    },
  },
}
</script>
